import React from 'react';
import escudoQuimsa from '../assets/escudo-quimsa.png';
const Header = () => {
  const headerStyle = {
    backgroundColor: 'white',
    padding: '15px 20px',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
    width: '100%'
  };

  const headerContentStyle = {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '1200px',
    margin: '0 auto'
  };

  const escudoStyle = {
    height: '90px',
    marginRight: '20px'
  };

  const textContainerStyle = {
    textAlign: 'left'
  };

  const clubNameStyle = {
    fontSize: '22px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '5px',
    textTransform: 'uppercase'
  };

  const locationStyle = {
    fontSize: '14px',
    color: '#666',
    textTransform: 'uppercase'
  };

  return (
    <header style={headerStyle}>
      <div style={headerContentStyle}>
        <img src={escudoQuimsa} alt="Escudo Quimsa" style={escudoStyle} />
        <div style={textContainerStyle}>
          <div style={clubNameStyle}>ASOCIACIÓN ATLÉTICA QUIMSA</div>
          <div style={locationStyle}>SANTIAGO DEL ESTERO</div>
        </div>
      </div>
    </header>
  );
};

export default Header;